import { loadable } from '@change-corgi/core/react/loadable';

import { Loading } from 'src/app/shared/routes';

export const Homepage = loadable(async () => import(/* webpackChunkName: "pages/homepage_v2" */ './entryPoint'), {
	exportName: 'Homepage',
	fallback: Loading,
});
